import { render, staticRenderFns } from "./ContentDocumentGrid.vue?vue&type=template&id=4152f332&"
import script from "./ContentDocumentGrid.vue?vue&type=script&lang=js&"
export * from "./ContentDocumentGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports